import React from 'react';
import { DataTestAttributes } from '../../constants/DataTestAttributes';
import { OrderSummaryWrapperContainer } from './styled';
import { OrderSummary, parseValueIntoString } from '@chegg/commerce-utils';
import { useAppSelector } from '../../hooks/useAppSelector';
import { configSelector } from '../../redux/config/config.selectors';
export var OrderSummaryWrapper = function OrderSummaryWrapper(_ref) {
  var price = _ref.price;
  var stateConfig = useAppSelector(configSelector);
  var orderSummaryContent = stateConfig.content.orderSummaryContent;
  var formattedTotalWithTax = parseValueIntoString(orderSummaryContent ? orderSummaryContent.totalPlusTax : '', price.subscriptionPrice, '${price}');
  return /*#__PURE__*/React.createElement(OrderSummaryWrapperContainer, {
    id: 'review-container',
    "data-test": DataTestAttributes.ORDER_SUMMARY_WRAPPER
  }, /*#__PURE__*/React.createElement(OrderSummary, {
    price: price,
    onError: function onError() {},
    content: orderSummaryContent,
    formattedTotalWithTax: formattedTotalWithTax
  }));
};
export default OrderSummaryWrapper;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/dropin-payments/dist/esm/components/OrderSummaryWrapper/OrderSummaryWrapper.js
// module id = 4662
// module chunks = 11